module.exports = __webpack_public_path__ + "2b4f1c4f883cf2679978820f47a60761.svg";